import { FC } from 'react'
import classNames from 'classnames'
import { getShortURL, sanitizeUrl } from '@/utils'
import styles from './index.module.scss'

type Props = {
  isLink?: boolean
  href?: string
  name: string
  value?: string
  isMultiline?: boolean
}

export const StatusListItem: FC<Props> = ({ isLink = false, href = '/', name, value = '', isMultiline = false }) => {
  return (
    <div className={styles.container}>
      <div className={styles.name}>
        {name}
        <span>&nbsp;</span>:
      </div>
      <div
        className={classNames(styles.value, {
          [styles.wrap]: isMultiline,
        })}
      >
        {isLink ? (
          <a className={styles.link} href={sanitizeUrl(href)} target='_blank' rel='noreferrer'>
            {getShortURL(value)}
          </a>
        ) : (
          <>{value}</>
        )}
      </div>
    </div>
  )
}
